export default __webpack_public_path__ + "static/media/related-image-01.cda48b81.jpg";